import * as c from '../constants/UserConstants'
import template from './template'

const initialState = {
  isAuthenticating : false,
  isAuthed         : false,
  hasAccess        : true,
  fetching         : false,
  fetched          : false,
  error            : null
}

export default (state = initialState, action) => {
  switch (action.type) {
    case c.LOGOUT_USER:
      return initialState

    case c.LOGIN_USER_PENDING:
      return { ...state, isAuthenticating: true }

    case c.LOGIN_USER_FULFILLED:
      return { ...state, isAuthenticating: false, isAuthed: true }

    case c.FETCH_USER_DETAILS_DENIED:
      return { ...state, fetching: false, fetched: true, hasAccess: false }

    default:
      return template(state, action, c, 'USER_DETAILS')
  }
}
